import { IAgentSchema } from '@cian/api-models/offer-card/v1/get-offer-data';
import { defaultTo } from 'ramda';

import { getMasterAgentAvatar } from './getMasterAgentAvatar';
import { getMasterAgent } from './getMasterAgent';

export function getAgentAvatar(agent: IAgentSchema) {
  if (agent.isSubAgent) {
    const masterAgent = getMasterAgent(agent);

    return masterAgent ? getMasterAgentAvatar(masterAgent) : '';
  }

  return defaultTo('', agent.absoluteAvatarUrl);
}
